import store from '../../../../store/configureStore';

import AirQualityDataItem from '../../../data/airQuality/AirQualityDataItem';
import AirQualityData from '../../../data/airQuality/index';

let santized_field_name = (fieldName) => {
  let AirQualityParameters = AirQualityDataItem.PARAMETERS;
  if ((fieldName.match(/temp/i))) {
    return AirQualityParameters.TEMP.key;
  }
  if ((fieldName.match(/pm/i)) || (fieldName.match(/part/i)) || (fieldName.match(/dust/i))) {
    if ((fieldName.match(/2.5/i)) || (fieldName.match(/25/i)))
      return AirQualityParameters.PM2_5.key;
    if ((fieldName.match(/10/i)))
      return AirQualityParameters.PM10.key;
    return null;
  }
  if ((fieldName.match(/o3/i)) || (fieldName.match(/ozo/i))) {
    return AirQualityParameters.O3.key;
  }
  if ((fieldName.match(/no2/i)) ||
    ((fieldName.match(/nitr/i)) && (fieldName.match(/di/i)))) {
    return AirQualityParameters.NO2.key;
  }
  if ((fieldName.match(/h2s/i)) ||
    ((fieldName.match(/hyd/i)) && (fieldName.match(/sulp/i)))) {
    return AirQualityParameters.H2S.key;
  }
  if ((fieldName.match(/so2/i)) ||
    ((fieldName.match(/oxi/i)) && (fieldName.match(/sulp/i)))) {
    return AirQualityParameters.SO2.key;
  }
  if ((fieldName.match(/co/i)) ||
    ((fieldName.match(/carb/i)) && (fieldName.match(/mono/i)))) {
    return AirQualityParameters.CO.key;
  }
  return null;
};

class AirResultToAirQuality {
  constructor(data = {}, source_uid) {
    if (source_uid !== undefined) {
      let aqdiObjs = [];
      if ((data.results) && (data.results.length > 0)) {
        data.results.map((dataObj) => {
          if ((dataObj) && (dataObj.coordinates) && (dataObj.coordinates.latitude)
            && (dataObj.coordinates.longitude)) {
            let aqdi = {};
            aqdi.LOCATION = {
              lat: parseFloat(dataObj.coordinates.latitude),
              lng: parseFloat(dataObj.coordinates.longitude)
            };
            aqdi.CHANNEL_NAME = dataObj.location;
            if ((dataObj.type) && (dataObj.type === "iotAqm")) {
              aqdi.SOURCE = "ThingSpeak"
            }
            else {
              aqdi.SOURCE = "OpenAQ";
            }
            aqdi.SOURCE_ID = source_uid;
            let channels_set = new Set();
            let sensed_times_set = new Set();
            aqdi["MEASUREMENTS"] = {};
            aqdi["UNITS"] = {};
            if ((dataObj.measurements) && (dataObj.measurements.length > 0)) {
              dataObj.measurements.map((m) => {
                let sanitized_parameter = santized_field_name(m.parameter);
                if (sanitized_parameter !== null) {
                  aqdi["MEASUREMENTS"][sanitized_parameter] = m.value;
                  aqdi["UNITS"][sanitized_parameter] = m.unit;
                  channels_set.add(m.sourceName);
                  sensed_times_set.add(new Date(m.lastUpdated));
                }
              });
            }
            let latest_time = {};
            (Array.from(sensed_times_set)).map((time) => {
              if (latest_time.getTime) {
                if (latest_time.getTime() < time.getTime()) {
                  latest_time = time;
                }
              } else {
                latest_time = time;
              }
            });
            aqdi["SENSED_AT"] = latest_time;
            aqdi["CHANNEL_ID"] = (Array.from(channels_set)).reduce((channel_id, current_channel, index) => {
              return channel_id
                + ((index > 1) ? ('/') : (''))
                + current_channel;
            }, '');
            aqdiObjs.push(new AirQualityDataItem(aqdi));
          }
        });
        store.dispatch({
          type: AirQualityData.ACTIONS.ADD_AIR_QUALITY_DATA_ITEMS,
          data: aqdiObjs
        });
      }
    }
  }
}

export default AirResultToAirQuality;



// WEBPACK FOOTER //
// ./src/models/source/air/interfaces/AirResultToAirQuality.js